import { LinkButton } from '@strava/ui/Button';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './OnboardingLinkButton.scss';

const OnboardingLinkButton = ({ href, children }) => {
  return (
    <LinkButton
      className={styles.link}
      href={href}
      variant="text"
      target="blank"
    >
      {children}
    </LinkButton>
  );
};

OnboardingLinkButton.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default OnboardingLinkButton;
